<div matDialogTitle>Kontaktinformation</div>

<mat-divider />

<mat-dialog-content>
  <div class="text-accent" style="margin-bottom: 20px">
    Weitere Informationen zum Gesundheitsevent erhalten Sie bei der ego4you Kids & Teens Informationsstelle der Merkur
    Lifestyle:
  </div>

  <mng-mgs-kids-buchung-ml-info />

  <mat-divider />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close>OK</button>
</mat-dialog-actions>
